import { Avatar as ADAvatar } from "antd";
import { getInitials } from "../../utils/shared";
import { genericStyles } from "../../constant";

/**
 * Common Avatar Component
 * @param {import('antd').AvatarProps & {
 *  user?: string | { first_name?: string; last_name?: string; name?: string };
 * }} props
 * @property {object} [user] - Name or object used to generate initials
 */
const Avatar = ({
  user,
  children,
  src,
  size = 32,
  style = {},
  ...restProps
}) => {
  return (
    <ADAvatar
      src={src}
      size={size}
      style={{ background: genericStyles.primaryColor, ...style }}
      {...restProps}
    >
      {children ?? (!src && getInitials(user))}
    </ADAvatar>
  );
};

export default Avatar;
